import { cn } from "../lib/utils";
import { Button } from "./button";
import { Separator } from "./separator";
import { Typography } from "./typography";

export enum PageSelectionMode {
  pageAllSelected = "page_all_selected",
  allAcrossSelected = "all_across_selected",
}
type PageSelectionBannerProps = {
  mode: PageSelectionMode;
  x?: number;
  y: number;
  onSelectAllAcross?: () => void;
  onClear: () => void;
  className?: string;
};

const PageSelectionBanner: React.FC<PageSelectionBannerProps> = ({
  mode,
  x,
  y,
  onSelectAllAcross,
  onClear,
  className,
}) => {
  const isPageAll = mode === PageSelectionMode.pageAllSelected;

  return (
    <div
      className={cn(
        "flex justify-center items-center gap-2 bg-gray-100 rounded-custom h-7",
        className,
      )}
    >
      <Typography
        trans={isPageAll ? "page_selected" : "all_across_selected"}
        transParams={{ x: x ?? 0, y }}
      />
      <Separator
        orientation="vertical"
        className="h-4 bg-gray-900"
        thickness="thick"
      />
      <Button
        type="button"
        variant="link"
        className="underline p-0"
        onClick={isPageAll ? onSelectAllAcross : onClear}
      >
        <Typography
          trans={isPageAll ? "select_all_across" : "clear_selection"}
          transParams={{ y }}
        />
      </Button>
    </div>
  );
};

export { PageSelectionBanner };
